import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from '../EmptyState.types';

export const ShutterstockSubtitle: FC<IOuter> = () => (
  <FormattedMessage
    id="empty-state.free-from-wix-subtitle"
    values={{ clearAllButton: <FormattedMessage id="empty-state.free-from-wix-subtitle-clear-all" /> }}
  />
);
